import { Loading } from 'element-ui';

let loadingCount = 0;
let loading;

const startLoading = (targetObj) => {
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    target:targetObj,
    background: 'rgba(0, 0, 0, 0.7)'
  });
};

const endLoading = () => {
  loading.close();
};

export const showLoading = (targetObj) => {
  if (loadingCount === 0) {
    startLoading(targetObj);
  }
  loadingCount += 1;
};

export const hideLoading = () => {
  if (loadingCount <= 0) {
    return;
  }
  loadingCount -= 1;
  if (loadingCount === 0) {
    endLoading();
  }
};